import { Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Badge } from './shared';
import { useTagLabels } from '../api/useTagLabels';
import { tagTooltipText } from '../api/dataIssues';
import { useIsAdmin } from '../../../auth/useIsAdmin';

export function TagBadge({
    tag,
    dataIssues,
}: {
    tag: string;
    // The trader's data_issues; shown in the Data Error tooltip to admins only.
    dataIssues?: readonly string[];
}) {
    const theme = useTheme();
    const labels = useTagLabels();
    const isAdmin = useIsAdmin();
    const info = labels.get(tag);
    const color = info?.color ?? theme.palette.text.secondary;

    const badge = <Badge color={color}>{tag}</Badge>;

    const title = tagTooltipText(tag, info?.description, dataIssues, isAdmin);
    if (!title) return badge;

    return (
        <Tooltip title={title} placement="top" arrow>
            {/* Tooltip requires a single forwardRef child; span is the safe wrapper */}
            <span style={{ display: 'inline-flex' }}>{badge}</span>
        </Tooltip>
    );
}
